<template>
    <v-layout justify-center align-center column class="text-xs-center">
        <v-flex>
            <v-btn :loading="runningExploit"
                   :disabled="disableRunExploitButton"
                   @click.native="runExploit"
                   raised
                   large
                   ripple
                   color="red darken-4">
                Run Exploit <v-icon right>security</v-icon>
            </v-btn>
        </v-flex>
    </v-layout>
</template>
<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "run-exploit",
  computed: {
    ...mapGetters([
      "working",
      "connectDeviceComplete",
      "selectPayloadComplete"
    ]),
    ...mapState(["runningExploit"]),
    disableRunExploitButton() {
      return (
        this.working ||
        !(this.connectDeviceComplete && this.selectPayloadComplete)
      );
    }
  },
  methods: {
    runExploit() {
      this.$store.dispatch("runExploit");
    }
  }
};
</script>
